import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_DOCLIGNE_SCHEMA_LITERAL = {
    title: 'Schéma LigneDocument',
    description: 'Document',
    version: 5,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        USER_ID: { type: 'string' },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        CBMARQ : { type : 'number' },
        MD_CBMARQ : { type : 'number' },
        DL_NO : { type : 'number' },
        DO_PIECE : { type : 'string' },
        DO_DATE : { type : 'string' },
        DO_TYPE: { type: 'number' },
        DO_PIECE_INTERNAL : { type : 'string' },
        CT_NUM : { type : 'string' },
        CA_NUM : { type : ['string', 'null'] },
        CA_INTITULE : { type : ['string', 'null'] },
        DO_REF : { type : ['string', 'null'] },
        DL_LIGNE: { type: 'number' },
        DE_NO: { type: 'number' },
        DE_INTITULE: { type: 'string' },
        AR_REF: { type: 'string', default : '' },
        FA_CODEFAMILLE: { type: 'string', default : '' },
        AR_REFCOMPOSE: { type: 'string', default : '' },
        DL_DESIGN: { type: 'string' },
        AG_NO1: { type: 'number' },
        AG_NO1LIB: { type: 'string', default : '' },
        AG_NO2: { type: 'number' },
        AG_NO2LIB: { type: 'string', default : '' },
        AR_SUIVISTOCK : { type : 'number' },
        LS_NOSERIE : { type : 'string' },
        LS_COMPLEMENT : { type : 'string' },
        LS_PEREMPTION : { type : ['string', 'null'] },
        LS_FABRICATION : { type : ['string', 'null'] },
        LS_QTE : { type : 'number' },
        DL_QTE: { type: 'number' },
        DL_POIDSNET : { type : ['number', 'null'] },
        DL_POIDSBRUT : { type : ['number', 'null'] },
        DL_PRIXUNITAIRE: { type: 'number' },
        DL_PRIXUNITAIRE_NC: { type: 'number' },
        DL_PRIXUNITAIRE_NET: { type: 'number' },
        DL_REMISE01REM_VALEUR: { type: 'number' },
        DL_REMISE01REM_TYPE: { type: 'number' },
        DL_REMISE02REM_VALEUR: { type: 'number' },
        DL_REMISE02REM_TYPE: { type: 'number' },
        DL_REMISE03REM_VALEUR: { type: 'number' },
        DL_REMISE03REM_TYPE: { type: 'number' },
        DL_REMISE_LIB: { type: ['string', 'null'] },
        DL_TAXE1: { type: 'number' },
        DL_CODETAXE1: { type: 'string' },
        DL_TYPETAUX1: { type: 'number' },
        DL_TYPETAXE1: { type: 'number' },
        DL_TAXE2: { type: 'number' },
        DL_CODETAXE2: { type: 'string' },
        DL_TYPETAUX2: { type: 'number' },
        DL_TYPETAXE2: { type: 'number' },
        DL_TAXE3: { type: 'number' },
        DL_CODETAXE3: { type: 'string' },
        DL_TYPETAUX3: { type: 'number' },
        DL_TYPETAXE3: { type: 'number' },
        EU_QTE: { type: 'number' },
        EU_ENUMERE: { type: 'string' },
        DL_TTC: { type: 'number', default : 0 },
        DL_PUTTC: { type: 'number', default : 0 },
        DL_PUTTC_NC: { type: 'number', default : 0 },
        DL_PUTTC_NET: { type: 'number', default : 0 },
        DL_MONTANTHT: { type: 'number', default : 0 },
        DL_MONTANTTTC: { type: 'number', default : 0 },
        DL_VALORISE : { type : 'number', default : 0 },
        DL_TIMBRE : { type : 'number', default : 0 },
        DL_REMISEG : { type : 'number', default : 0 },
        DL_NOSOUSTOTAL: { type: 'number', default : 0 },
        EST_SOUSTOTAL: { type: 'boolean', default : false },
        NBLIGNES_SOUSTOTAL : { type: 'number', default : 0 },
        DL_LCREC: { type: 'number' },
        DL_LCREC_DATE: { type: ['string', 'null'] },
        LC_REC_PTS_NB: { type: 'number' },
        LC_PG_GID: { type: ['string', 'null'] },
        LC_REC_GID: { type: ['string', 'null'] },
        LC_REC_TYPE: { type: 'number' },
        DL_GIFTCARD: { type: 'boolean' },
        DL_GF_CARTE_NUM: { type: ['string', 'null'] },
        DL_GF_CARTE_DESIGNATION: { type: ['string', 'null'] },
        DL_GF_C_TOTAL_TTC_INIT: { type: 'number' },
        DL_GF_DATE_DEBUT: { type: ['string', 'null'] },
        DL_GF_DATE_EXP: { type: ['string', 'null'] },
        CL_EXTRAS  : { type : ['string', 'null'] }, 
        DL_ESCOMPTE: { type: ['number', 'null'] },
        DL_PIECEDE  : { type : ['string', 'null'] }, 
        DL_PIECEBC  : { type : ['string', 'null'] }, 
        DL_PIECEPL  : { type : ['string', 'null'] }, 
        DL_PIECEBL  : { type : ['string', 'null'] }, 
        DL_DATEDE  : { type : ['string', 'null'] }, 
        DL_DATEBC  : { type : ['string', 'null'] }, 
        DL_DATEPL  : { type : ['string', 'null'] }, 
        DL_DATEBL  : { type : ['string', 'null'] }, 
        DL_QTEDE: { type: ['number', 'null'] }, 
        DL_QTEBC: { type: ['number', 'null'] }, 
        DL_QTEPL: { type: ['number', 'null'] }, 
        DL_QTEBL: { type: ['number', 'null'] }, 
        DL_PRIXRU: { type: ['number', 'null'] }, 
        DL_CMUP: { type: ['number', 'null'] }, 
        Z_CHECKED: { type: 'boolean', default : false }
    },
    required: [ 'MD_CBMARQ', 'DL_NO', 'DO_PIECE', 'DO_PIECE_INTERNAL', 'DL_LIGNE', 'DL_QTE', 'DL_PRIXUNITAIRE', 'DL_MONTANTHT', 'DL_MONTANTTTC', 'DL_NOSOUSTOTAL' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_DOCLIGNE_SCHEMA_LITERAL);
export type RxCluDocLigneDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_DOCLIGNE_SCHEMA: RxJsonSchema<RxCluDocLigneDocumentType> = CLU_DOCLIGNE_SCHEMA_LITERAL;
